import { _ as __read } from '../../../../tslib.es6-14c74580.js';
import React__default, { useState } from 'react';
import { RightSideIcon } from '../rightSideIcon/index.js';
import { MobileNavigationRow } from '../mobileNavigationRow/index.js';
import { TableMobileNavigation } from '../mobileNavigation/index.js';

var RightSideHolder = function (_a) {
    var navigationItems = _a.navigationItems;
    var _b = __read(useState(false), 2), activeOverlay = _b[0], setActiveOverlay = _b[1];
    var handleOnClose = function () {
        setActiveOverlay(false);
    };
    return (React__default.createElement("div", { className: 'pgc-right-side-holder' },
        activeOverlay && (React__default.createElement(TableMobileNavigation, { onClose: handleOnClose }, navigationItems.map(function (_a) {
            var icon = _a.icon, name = _a.name, isDisabled = _a.isDisabled, onClick = _a.onClick;
            return (React__default.createElement(MobileNavigationRow, { key: name, name: name, icon: icon, isDisabled: isDisabled, onClick: isDisabled ? function () {
                } : onClick }));
        }))),
        React__default.createElement(RightSideIcon, { setActiveOverlay: setActiveOverlay })));
};

export { RightSideHolder };
